export default __webpack_public_path__ + "assets/low.251b0c81314713bc0c7fcb0ba6269d63.mp3";